// extracted by mini-css-extract-plugin
export default {"wrapper":"OvmxKr","inner":"szZvF7","image":"s9VGyh","thumb":"NjrQBf"};